import {
  Alert,
  AlertTitle,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { ModalAcceptButton } from "../../../../constants/component.constants";
import { ResponsiveRow } from "../../../../constants/layout.constants";
import ModalContainerModule from "../../../modules/modalContainer";
import Permit from "../../../../util/permit";
import { useEffect, useState } from "react";
import {isNullUndefined} from "../../../../util/util";
import {getAllUnitOptions, getRateType} from "../../../../services/list.service";

export default function AddMeterModal(props) {
  /**
   *
   * REQUIRED PROPS
   *
   * AddDiv
   * bulkEdit
   * EditDiv
   * saveMeter
   *
   * handleAddMeterClose
   * handleInvoiceTenantToggle
   * handleMeterTypeChange
   * handleRateTypeChange
   * handleReadingFrequencyChange
   * handleTieredItemAdd
   * handleUnitOptionChange
   *
   * setComplex
   * setComplexId
   * setMeterName
   * setProperty
   * setRate
   * setStandingCharge
   *
   * Blwtr
   * complex
   * invoiceTenant
   * meterName
   * meterReadingPeriods
   * meterTypeCode
   * authorizedMeterTypes
   * meterTypeCode
   * property
   * rate
   * rateType
   * readingPeriod
   * selectedMeter
   * standingCharge
   * tieredItemsTableRows
   * tieredItemsTotal
   * unitId
   * isMeterTaxed
   * handleMeterTaxedToggle
   *
   */

  const [unitOptions, setUnitOptions] = useState([]);
  const [rateTypeOptions, setRateTypeOptions] = useState([])

  useEffect(() => {
    if (!isNullUndefined(props.selectedMeter)) {
      getAllUnitOptions(props.selectedMeter.facilityId).then((options) =>
          setUnitOptions(options)
      );
    }

    getRateType().then((options) =>
        setRateTypeOptions(options)
    );
  }, []);

  return (
    <ModalContainerModule
      size={"small"}
      accept={props.bulkEdit ? props.bulkEditMeters : props.saveMeter}
      cancel={props.handleAddMeterClose}
      openModal={props.AddDiv}
      modalTitle={props.EditDiv ? "Edit Meter" : "Add Meter"}
      acceptButtonText={
        !props.EditDiv ? "Create" : props.bulkEdit ? "Save Bulk Edit" : "Update"
      }
    >
      <ResponsiveRow
        container
        sx={{
          width: "100%",
          height: "auto",

          justifyContent: "flex-start",
          alignItems: "flex-start",
        }}
      >
        {!props.bulkEdit && (
          <FormControl
            required={true}
            sx={{ width: { xs: "100%", lg: "50%" }, marginBottom: "10px" }}
          >
            {/* required */}
            <InputLabel>Meter Name</InputLabel>
            <OutlinedInput
              label="Meter Name"
              id="meterName"
              sx={{
                width: { xs: "100%", md: "90%" },
                marginBottom: "10px",
              }}
              onChange={(event) => {
                const value = event.target.value;
                props.setMeterName(value);
                let obj = props.selectedMeter;
                obj.name = value;
              }}
              value={
                props.selectedMeter
                  ? props.selectedMeter && props.selectedMeter.name
                  : props.meterName
              }
              inputProps={
                <TextField
                  sx={{
                    width: { xs: "100%", md: "90%" },
                  }}
                />
              }
            />
          </FormControl>
        )}
        <Permit services={"PREMIUM,HOA,METER,BLWTR,CORE,LEAN"}>
          <FormControl
            required={true}
            sx={{ width: { xs: "100%", lg: "50%" }, marginBottom: "10px" }}
          >
            {/* required */}
            <InputLabel>Meter Reading Frequency</InputLabel>
            <Select
              label="Meter Reading Frequency"
              sx={{ width: { xs: "100%", md: "90%" }, marginBottom: "10px" }}
              id={"readingPeriod"}
              disabled={props.Blwtr}
              value={
                props.selectedMeter
                  ? props.selectedMeter && props.selectedMeter.readingFrequency
                  : props.readingPeriod
              }
              onChange={(event) => props.handleReadingFrequencyChange(event)}
            >
              {props.meterReadingPeriods &&
              props.meterReadingPeriods.length > 0 ? (
                props.meterReadingPeriods.map(function (readingPeriod, i) {
                  return (
                    <MenuItem key={i} value={readingPeriod.value}>
                      {readingPeriod.label}
                    </MenuItem>
                  );
                }, this)
              ) : (
                <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
              )}
            </Select>
          </FormControl>
        </Permit>
        {!props.bulkEdit && (
          <FormControl
            required={true}
            sx={{ width: { xs: "100%", lg: "50%" }, marginBottom: "10px" }}
          >
            {/* required */}
            <InputLabel>Meter Type</InputLabel>
            <Select
              sx={{ width: { xs: "100%", md: "90%" }, marginBottom: "10px" }}
              id={"type"}
              label="Meter Type"
              value={
                props.selectedMeter
                  ? props.selectedMeter && props.selectedMeter.meterTypeCode
                  : props.meterTypeCode
              }
              onChange={(event) => props.handleMeterTypeChange(event)}
            >
              {props.authorizedMeterTypes && props.authorizedMeterTypes.length > 0 ? (
                props.authorizedMeterTypes.map(function (meter, i) {
                  return (
                    <MenuItem key={i} value={meter.value}>
                      {meter.label}
                    </MenuItem>
                  );
                }, this)
              ) : (
                <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
              )}
            </Select>
          </FormControl>
        )}
        {!props.bulkEdit && !props.Blwtr && !["EU", "WU", "PEU"].includes(props.selectedMeter.meterTypeCode) && (
          <Grid
            item
            sx={{
              width: { xs: "100%", lg: "33.3%" },
              marginBottom: "10px",
            }}
          >
            <InputLabel required>Attach Meter To:</InputLabel>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              <FormControlLabel
                value="Property"
                checked={props.property}
                control={
                  <Radio
                    onChange={() => {
                      props.setProperty(true);
                      props.setComplex(false);
                      props.setComplexId("");
                    }}
                  />
                }
                label="Property"
              />
              {props.isWithinComplex && (
                <FormControlLabel
                  value="Complex"
                  checked={props.complex}
                  control={
                    <Radio
                      onChange={() => {
                        props.setComplex(true);
                        props.setProperty(false);
                      }}
                    />
                  }
                  key={props.isWithinComplex}
                  label="Complex"
                />
              )}
            </RadioGroup>
            <br />
          </Grid>
        )}
          {props.selectedMeter &&
            !props.bulkEdit &&
            (props.selectedMeter.meterTypeCode === "WU" ||
              props.selectedMeter.meterTypeCode === "EU") && (
              <Permit services={"PREMIUM,HOA,BLWTR,CORE,LEAN"}>
                <FormControl
                  sx={{ width: { xs: "100%", lg: "50%" }, marginBottom: "10px" }}
                >
                  <InputLabel>Unit</InputLabel>
                  <Select
                    label="Unit"
                    sx={{ width: { xs: "100%", md: "90%" } }}
                    id={"type"}
                    value={
                      props.selectedMeter
                        ? props.selectedMeter && props.selectedMeter.unitId
                        : props.unitId ? props.unitId : ""
                    }
                    onChange={(event) => props.handleUnitOptionChange(event)}
                  >
                    {unitOptions && unitOptions.length > 0 ? (
                      unitOptions.map(function (unit, i) {
                        return (
                          <MenuItem key={i} value={unit.value}>
                            {unit.label}
                          </MenuItem>
                        );
                      }, this)
                    ) : (
                      <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Permit>
            )}

        <Permit services={"PREMIUM,HOA,METER,BLWTR,CORE,LEAN"}>
          {props.selectedMeter &&
            (props.selectedMeter.meterTypeCode === "WU" ||
              props.selectedMeter.meterTypeCode === "EU" ||
              props.bulkEdit) && (
              <FormControl
                sx={{ width: { xs: "100%", lg: "50%" }, marginBottom: "10px" }}
              >
                <InputLabel>Rate Type</InputLabel>
                <Select
                  label="Rate Type"
                  sx={{ width: { xs: "100%", md: "90%" } }}
                  id={"type"}
                  value={
                    props.selectedMeter
                      ? props.selectedMeter && props.selectedMeter.rateTypeCode
                      : props.rateType ? props.rateType : ""
                  }
                  onChange={(event) => props.handleRateTypeChange(event)}
                >
                  {rateTypeOptions.length > 0 ? (
                    rateTypeOptions.map(function (rateType, i) {
                      return (
                        <MenuItem key={i} value={rateType.value}>
                          {rateType.label}
                        </MenuItem>
                      );
                    }, this)
                  ) : (
                    <MenuItem sx={{ width: "100%" }}>No Results Found</MenuItem>
                  )}
                </Select>
              </FormControl>
            )}

          {props.selectedMeter &&
            props.selectedMeter.rateTypeCode === "FIX" && (
              <FormControl
                sx={{ width: { xs: "100%", lg: "50%" }, marginBottom: "10px" }}
              >
                <InputLabel>
                  {props.Blwtr ? "Rate (Price per Liter)" : "Rate"}
                </InputLabel>
                <OutlinedInput
                  label={props.Blwtr ? "Rate (Price per Liter)" : "Rate"}
                  id="meterName"
                  sx={{
                    width: { xs: "100%", md: "90%" },
                  }}
                  onChange={(event) => {
                    const value = event.target.value;
                    props.setRate(value);
                    let obj = props.selectedMeter;
                    obj.rate = value;
                  }}
                  value={
                    props.selectedMeter
                      ? props.selectedMeter && props.selectedMeter.rate
                      : props.rate
                  }
                  inputProps={
                    <TextField
                      sx={{
                        width: { xs: "100%", md: "90%" },
                      }}
                    />
                  }
                />
              </FormControl>
            )}
          {props.selectedMeter && (props.invoiced || props.selectedMeter.invoiced) &&
            ((props.selectedMeter.meterTypeCode === "WU") ||
             (props.selectedMeter.meterTypeCode === "EU")) && (
            <FormControl
              sx={{ width: { xs: "100%", lg: "50%" }, marginBottom: "10px" }}
            >
              <InputLabel>Standing Charge</InputLabel>
              <OutlinedInput
                label="Standing Charge"
                id="meterName"
                sx={{
                  width: { xs: "100%", md: "90%" },
                }}
                onChange={(event) => {
                  const value = event.target.value;
                  props.setStandingCharge(value);
                  let obj = props.selectedMeter;
                  obj.standingCharge = value;
                }}
                value={
                  props.selectedMeter
                    ? props.selectedMeter &&
                      props.selectedMeter.standingCharge
                    : props.standingCharge
                }
                inputProps={
                  <TextField
                    sx={{
                      width: { xs: "100%", md: "90%" },
                    }}
                  />
                }
              />
            </FormControl>
          )}
          {props.selectedMeter &&
            (["BLK","EU","WU","OTH","PEU","RTL"].includes(props.selectedMeter.meterTypeCode)) && (
              <Grid
                item
                sx={{ width: { xs: "100%", lg: "50%" }, marginBottom: "10px" }}
              >
                <Permit services={"HOA"}>
                  <InputLabel>Is Meter Invoiced?</InputLabel>
                </Permit>
                <Permit services={"PREMIUM,METER,CORE,LEAN"}>
                  <InputLabel>Is this meter invoiced to the unit tenant?</InputLabel>
                </Permit>
                <Switch
                  checked={
                    props.selectedMeter
                      ? props.selectedMeter.invoiced
                      : props.invoiced
                  }
                  onChange={(event) => props.handleInvoicedToggle(event)}
                  inputProps={{ "aria-label": "controlled" }}
                />
              </Grid>
            )}
            {props.selectedMeter && props.selectedMeter.meterTypeCode === "EU" && (props.invoiced || props.selectedMeter.invoiced) && props.selectedMeter.rateTypeCode && (
              <Grid
                  item
                  sx={{ width: { xs: "100%", lg: "50%" }, marginBottom: "10px"}}
                >
                  <InputLabel>
                    Is this Meter Taxed?
                  </InputLabel>
                  <Switch
                    checked={props.isMeterTaxed}
                    onChange={props.handleMeterTaxedToggle}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </Grid>
            )}
        </Permit>
      </ResponsiveRow>

      <br />

      {props.selectedMeter && props.selectedMeter.rateTypeCode === "TIERD" && (
        <ResponsiveRow sx={{ height: "auto", margin: "auto", padding: "10px" }}>
          <Typography
            sx={{ marginBottom: "5px" }}
            id="modal-modal-title"
            variant="h5"
            component="h4"
          >
            Meter Table
          </Typography>
          <TableContainer>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: "30%" }}>Minimum Units</TableCell>
                  <TableCell sx={{ width: "30%" }}>Maximum Units</TableCell>
                  <TableCell sx={{ width: "30%" }}>Charge per Unit</TableCell>
                  <TableCell sx={{ width: "10%" }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{props.tieredItemsTableRows}</TableBody>
            </Table>
          </TableContainer>
          <ResponsiveRow container>
            <Alert sx={{ width: "100%" }} severity="info">
              <AlertTitle>Total: {props.tieredItemsTotal}</AlertTitle>
            </Alert>
          </ResponsiveRow>
          <ResponsiveRow
            item
            sx={{ justifyContent: { xs: "center", lg: "flex-end" } }}
          >
            <ModalAcceptButton
              //   type="submit"
              onClick={() => props.handleTieredItemAdd()}
              sx={{ width: { xs: "100%", lg: "200px" } }}
            >
              {" "}
              Add row{" "}
            </ModalAcceptButton>
          </ResponsiveRow>
        </ResponsiveRow>
      )}
    </ModalContainerModule>
  );
}
